// Maps the fully-qualified celery task name (as reported by the backend running-tasks
// route) to a user-friendly German title shown in the "Server" tab. Unknown task names
// fall back to the last segment of the task name (see getTaskTitle).
const TASK_TITLE_BY_NAME: Record<string, string> = {
  'md_core.worker.full_computation.tasks.full_computation_task': 'Vollständige Berechnung',
  'md_core.worker.wind_loads.tasks.configure_wind_load_task': 'Windlasten berechnen',
  'md_core.worker.align_walls.tasks.align_walls_vertically': 'Wände vertikal ausrichten',
  'md_core.worker.align_walls.tasks.align_selected_walls_vertically':
    'Ausgewählte Wände ausrichten',
  'md_core.worker.horizontal.tasks.compute_horizontal_transmission':
    'Horizontale Weiterleitung berechnen',
  'md_core.worker.vertical.tasks.vertical_transmission_task': 'Vertikale Weiterleitung berechnen',
  'md_core.worker.tensile.tasks.tensile_transmission_task': 'Zugweiterleitung berechnen',
  'md_core.worker.calc_member_checks.tasks.calc_single_position_check':
    'Positionsnachweis berechnen',
  'md_core.worker.calc_member_checks_pure.tasks.calc_pure_position_check':
    'Positionsnachweis berechnen',
  'md_core.worker.calc_member_checks_pure.tasks.calc_position_check_write_back':
    'Positionsnachweis speichern',
  'md_core.worker.checks.tasks.compute_element_check_bundle': 'Elementnachweise berechnen',
  'md_core.worker.anchor_checks.tasks.compute_anchor_checks': 'Ankernachweise berechnen',
  'md_core.worker.ifc_glb_conversion.tasks.ifc_to_glb_task': 'IFC-Modell konvertieren',
  'md_core.worker.ifc_parse.tasks.parse_ifc_wall_task': 'IFC-Wände importieren',
  'md_core.worker.ifc_parse.tasks.parse_ifc_opening_into_wall_task': 'IFC-Öffnungen importieren',
  'md_core.worker.ifc_parse.tasks.parse_ifc_roof_slab_task': 'IFC-Dachdecken importieren',
  'md_core.worker.export.tasks.create_member_checks_doc': 'Nachweisdokument erstellen',
  'md_core.worker.export.tasks.create_member_checks_doc_for_storey':
    'Nachweisdokument (Geschoss) erstellen',
  'md_core.worker.export.tasks.create_shear_modulus_doc': 'Schubmoduldokument erstellen',
  'md_core.worker.export.template_tasks.create_template_preview_task': 'Dokumentvorschau erstellen',
  'md_core.worker.export.tasks.convert_project_file_to_pdf': 'PDF erstellen',
}

// Celery reports fully-qualified task names (e.g.
// "md_core.worker.full_computation.tasks.full_computation_task"). Use the mapped German
// title, falling back to the last name segment for tasks that are not (yet) mapped.
export const getTaskTitle = (taskName: string): string =>
  TASK_TITLE_BY_NAME[taskName] ?? taskName.split('.').pop() ?? taskName
